export function PageHeader({ overline, title, subtitle, children }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8 fade-up">
      <div className="min-w-0">
        {overline && <div className="overline text-orangeink mb-2">{overline}</div>}
        <h1 className="font-heading font-bold text-3xl sm:text-4xl tracking-tight text-navy">{title}</h1>
        {subtitle && <p className="text-slate-600 mt-2 text-sm leading-relaxed">{subtitle}</p>}
      </div>
      {children && <div className="flex items-center gap-2.5 shrink-0 flex-wrap">{children}</div>}
    </div>
  );
}

const MAP = {
  Active: "bg-orange/10 text-orangeink",
  Scheduled: "bg-slate-100 text-slate-600",
  Completed: "bg-positive/10 text-positive",
  Posted: "bg-positive/10 text-positive",
  Pending: "bg-warn/15 text-warn",
  Cancelled: "bg-slate-100 text-slate-600 line-through",
  Inactive: "bg-negative/10 text-negative",
  Unscheduled: "bg-warn/15 text-warn",
  Reconciled: "bg-positive/10 text-positive",
  Variance: "bg-negative/10 text-negative",
  Tie: "bg-positive/10 text-positive",
  "No Xero balance": "bg-warn/15 text-warn",
  PREPAYMENT: "bg-orange/10 text-orangeink",
  ACCRUAL: "bg-navy/[0.07] text-navy",
  DEFERRED_INCOME: "bg-positive/10 text-positive",
  DEPRECIATION: "bg-warn/15 text-warn",
  Disposed: "bg-slate-100 text-slate-600",
};

export function StatusBadge({ value, testid }) {
  const cls = MAP[value] || "bg-slate-100 text-slate-600";
  return (
    <span data-testid={testid}
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-[0.68rem] font-semibold uppercase tracking-wider ${cls}`}>
      {String(value).replace(/_/g, " ")}
    </span>
  );
}

export function Page({ children }) {
  return <div className="px-6 sm:px-8 py-8 max-w-[1480px] mx-auto">{children}</div>;
}
